import React, { useState } from "react";
import { Button, Grid, Paper as MuiPaper, TextField } from "@mui/material";
import WithdrawInfo from "./WithdrawInfo";
import styled from "styled-components/macro";
import { spacing } from "@mui/system";
import convertUSD from "../../../utils/convertUSD";

const Paper = styled(MuiPaper)(spacing);

const WithdrawStep1 = ({
  loading,
  withdraw,
  withdrawOptions,
  user,
  userOptions,
  onPrevious,
  onNext,
  previousDisabled,
  nextDisabled,
}) => {
  const [zenDeskURL, setZenDeskURL] = useState(withdraw.zendeskTicketId);

  return (
    <>
      <Grid item xs={12}>
        <Paper p={4} elevation={0}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid container spacing={4} wrap="nowrap" alignItems="center">
                    <Grid item>
                      <TextField
                        value={zenDeskURL}
                        onChange={(event) => setZenDeskURL(event.target.value)}
                        label="ZenDesk Ticket ID"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item>
                      <Button>Go To ZenDesk</Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="User ID"
                    value={withdraw.userId}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="User Name"
                    value={user.name}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="Amount Requested by User"
                    value={convertUSD(withdraw.amount)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="PayPal Email"
                    value={user.paypalEmail}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="User Email"
                    value={user.email}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="First Name"
                    value={user.firstName}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="Last Name"
                    value={user.lastName}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="Street Address"
                    value={user.streetAddress}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="Street Address 2"
                    value={user.streetAddressSecond}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="Country"
                    value={user.country}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="City"
                    value={user.city}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="State/Province"
                    value={user.state}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WithdrawInfo
                    loading={loading}
                    title="Postal Code"
                    value={user.postalCode}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper p={4} elevation={0}>
          <Grid container spacing={4} alignItems="center">
            <Grid item>
              <Button
                size="small"
                variant="text"
                color="primary"
                disabled={loading || previousDisabled}
                onClick={onPrevious}
              >
                Previous Step
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="contained"
                color="primary"
                disabled={loading || nextDisabled}
                onClick={onNext}
              >
                Next Step
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default WithdrawStep1;
